import httpClient from '@/http-client'

export const get = (options = {}) => {
	return httpClient
		.get('/api/portfolio-photos', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const store = data => {
	return httpClient
		.post('/api/portfolio-photos', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/portfolio-photos/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const update = data => {
	return httpClient
		.put(`/api/portfolio-photos/${data.upload_id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
	return httpClient
		.delete(`/api/portfolio-photos/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const download = id => {
	return httpClient
		.get(`/api/portfolio-photos/downloads/${id}`, {
			responseType: 'arraybuffer'
		})
		.then(response => Promise.resolve(response.data))
		.catch(response => Promise.reject(response.data))
}
export const removePhoto = id => {
	return httpClient
		.get(`/api/portfolio-photos/remove-photos/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(response => Promise.reject(response.data))
}
export const removeFile = (Options = {}) => {
	return httpClient
		.get('/api/portfolio-photos/remove-files', Options)
		.then(response => Promise.resolve(response.data))
		.catch(response => Promise.reject(response.data))
}
export const portfolioType = (options = {}) => {
	return httpClient
		.get('/api/portfolio-photos/portfolio-types', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const releasePortfolio = data => {
	return httpClient
		.post('/api/portfolio-photos/release-portfolios', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const previewListPortfolio = data => {
	return httpClient
		.post('/api/portfolio-photos/preview-lists', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	store,
	find,
	update,
	destroy,
	download,
	removePhoto,
	removeFile,
	portfolioType,
	releasePortfolio,
	previewListPortfolio
}
